module.exports = __webpack_public_path__ + "img/avatar-woman.3a991af4.svg";